import { createAction } from '@reduxjs/toolkit';

import {
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  RESEND_OTP_REQUEST,
  VERIFY_OTP_REQUEST,
  VERIFY_INVITE_TOKEN,
  VERIFY_INVITE_TOKEN_SUCCESS,
  VERIFY_INVITE_TOKEN_FAILURE,
  RESEND_OTP_SUCCESS,
  RESEND_OTP_FAILURE,
  RESET_INVITE_REQUEST,
} from './signUp.const';

export const signUpAction = createAction(SIGNUP_REQUEST);
export const signUpSuccessAction = createAction(SIGNUP_SUCCESS);
export const signUpFailureAction = createAction(SIGNUP_FAILURE);

export const resendOTPAction = createAction(RESEND_OTP_REQUEST);
export const resendOTPSuccessAction = createAction(RESEND_OTP_SUCCESS);
export const resendOTPFailureAction = createAction(RESEND_OTP_FAILURE);

export const verifyOTPAction = createAction(VERIFY_OTP_REQUEST);

export const verifyInviteToken = createAction(VERIFY_INVITE_TOKEN);
export const verifyInviteTokenSuccess = createAction(VERIFY_INVITE_TOKEN_SUCCESS);
export const verifyInviteTokenFailure = createAction(VERIFY_INVITE_TOKEN_FAILURE);

export const resetInviteRequest = createAction(RESET_INVITE_REQUEST);
